import { EnvironmentModel, IOHURLS } from './environment.model';
import { Endpoints } from './endpoints';

export const IOH: IOHURLS = {
  // userServiceBaseURL: 'http://localhost:3000',
  // patientServiceBaseURL: 'http://localhost:3001',
  // cdsServiceBaseUrl: 'http://localhost:3000',
  // rulesServiceBaseUrl: 'http://localhost:3000',
  // reportsServiceBaseUrl: 'http://localhost:3000',
  userServiceBaseURL: 'http://portal.dev.iohealthtech.com',
  patientServiceBaseURL: 'http://portal.dev.iohealthtech.com',
  cdsServiceBaseUrl: 'http://portal.dev.iohealthtech.com',
  rulesServiceBaseUrl: 'http://portal.dev.iohealthtech.com',
  reportsServiceBaseUrl: 'http://portal.dev.iohealthtech.com',
};

const endpoints = new Endpoints();
export const environment: EnvironmentModel = {
  production: false,
  posthogApiKey: 'ioh-client-telemetry',
  telemetryEnabled: false,
  cognito: {
    userPoolId: 'us-east-1_qmQdTL7VB',
    userPoolWebClientId: '1vldcbffsofvpin6jv89c67lgl',
    region: 'us-east-1',
    // Not yet confirmed against this App Client's actual Cognito settings — defaulted to
    // AWS's out-of-the-box values. Update to match if this App Client is configured differently.
    accessTokenExpiryMinutes: 60,
    refreshTokenExpiryMinutes: 60,
  },
  endPoints: { ...endpoints.getGenericEndpoints() },
  awsCredentials: {
    region: 'us-east-2',
    signatureVersion: 'v4',
  },
};
